import XTbl,{Xtc} from '../../../../components/x-table';
const tbl = new XTbl('/account/list/', 'Users');

tbl.add(new Xtc('first_name', 'FirstName'))
tbl.add(new Xtc('last_name', 'LastName'))
tbl.add(new Xtc('email_address', 'Email'))
tbl.add(new Xtc('permission', 'Permission').noSort().renderSlot('roles'))
tbl.add(new Xtc('action', 'Action').noSort().renderSlot('action'))

export default tbl;

